import React, { useState, useEffect, useRef } from "react";
import { Container, Overlay, Table, Tooltip } from "react-bootstrap";
import listicon from "../assets/images/list.svg";
import cardicon from "../assets/images/cardicon.svg";
import filtericon from "../assets/images/filter.svg";
import addicon from "../assets/images/addicon.svg";
import historyAction from "../assets/images/historyaction.svg";
import notificationAction from "../assets/images/notificationaction.svg";
import viewAction from "../assets/images/viewaction.svg";
import editAction from "../assets/images/editaction.svg";
import actionLog from "../assets/images/actionLog.svg";
import deleteAction from "../assets/images/deleteaction.svg";
import playAction from "../assets/images/playaction.svg";
import closeAction from "../assets/images/closeRed.svg";
import homeImage from "../assets/images/home.svg";
import activestatus from "../assets/images/activeStatus.svg";
import download from "../assets/images/download.svg";
import inactivestatus from "../assets/images/inactivestatus.svg";
import { Link, useNavigate } from "react-router-dom";
import SingleProjectCard from "./common-component/SingleProjectCard";
import LogModal from "./common-component/LogModal";
import {
    GetScheduleList,
    WorkFlowGetList,
} from "../services/ReduxTookit/Slice/WorkFlowRedux";
import { useDispatch, useSelector } from "react-redux";
import Loader, { LoaderType } from "./common-component/Loader";
import { commonservices, TIMEZONE_LIST } from "../services/CommonServices";
import Nodata from "./common-component/Nodata";
import DeleteModal from "../Modals/DeleteModal";
import NotificationPopup from "./common-component/NotificationPopup";
import { API_URL } from "../services/APIRoute";
import WorkFlowLogModal from "./common-component/WorkFlowLogModal";
import cronstrue from "cronstrue";
import profileicon from "../assets/images/dummy-profile-pic.jpg";
import WorkFlowTimeLine from "./WorkFlowTimeLine";
function Schedular() {
    const [modalShow, setModalShow] = useState(false);
    const [workflowList, setWorkflowList] = useState(null);

    const [Loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [modalShow1, setModalShow1] = useState(false);
    const [DeletePayload, setDeletePayload] = useState({
        workflowid: "",
        status: "",
    });
    const overlayNoti_Ref = useRef(null);
    let navigate = useNavigate();
    const [logId, setLogId] = useState("");
    const [filter, setFilter] = useState([]);

    const target2 = useRef(null);
    const [showNotification, setShowNotification] = useState(false);

    const getTimeZoneObj = (timezone) => {
        let filterdData = TIMEZONE_LIST?.filter((x) => x?.value === timezone);
        return filterdData;
    };

    const getWorkFlowGetListData = useSelector(
        (item) => item?.workflowredux?.GetScheduleListData?.data
    );

    const handleshowNotification = () => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowNotification(!showNotification);
    };
    useEffect(() => {
        if (getWorkFlowGetListData && getWorkFlowGetListData?.isValidate) {
            setWorkflowList(getWorkFlowGetListData?.data?.data);
            setLoading(false);
        }
        if (getWorkFlowGetListData && !getWorkFlowGetListData?.isValidate) {
            setWorkflowList(null);
            setLoading(false);
        }
    }, [getWorkFlowGetListData]);
    const handleOutsideClick = (event) => {
        if (
            overlayNoti_Ref.current &&
            !overlayNoti_Ref.current.contains(event.target) &&
            !target2.current.contains(event.target)
        ) {
            handleshowNotification(event); // Close the overlay
        }
    };

    useEffect(() => {
        if (showNotification) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [showNotification]);

    function getWorkFlowList(name, status) {
        setLoading(true);
        let body = {};
        if (name) {
            body["workflowname"] = name;
        }

        if (status) {
            body["status"] = status;
        }
        dispatch(GetScheduleList(body));
    }
    useEffect(() => {
        getWorkFlowList();
    }, []);

    const MemberListFunction = (id) => {
        let data = workflowList?.datalist4?.filter((x) => x?.workflowid === id);
        return data;
    };
    return (
        <div className="schedular-page-main all-page-top">
            <Container>
                <div className="top-bot-section flex-column align-items-start gap-3">
                    <h6>
                        <img
                            src={homeImage}
                            alt="home"
                            title="home"
                            style={{ cursor: "pointer", marginBottom: "3px" }}
                            onClick={() => navigate("/")}
                        />
                        <span style={{ fontWeight: "400", color: "#666666" }}>{" | "}</span>
                        <span className="mt-1">
                            {/* Workflow {workflowList?.length > 0  && `(${workflowList?.length})`} */}
                            Scheduler
                        </span>
                    </h6>
                    <div className="my-machine-top-boxes-wrapper">
                        <div className="my-machine-top-box-single total-machines in-process-machines scheduler-status-box">
                            <div>
                                <h4>
                                    {workflowList?.datalist2?.[0]?.total > 0
                                        ? workflowList?.datalist2?.[0]?.total
                                        : 0}{" "}
                                </h4>
                            </div>

                            <p>Workflow</p>
                        </div>
                        <div className="my-machine-top-box-single pending-machines approved-machines scheduler-status-box">
                            <div>
                                <h4>
                                    {workflowList?.datalist2?.[0]?.totalactive > 0
                                        ? workflowList?.datalist2?.[0]?.totalactive
                                        : 0}
                                    <span>Active</span>
                                </h4>
                                <h4>
                                    {workflowList?.datalist2?.[0]?.totalsuspend > 0
                                        ? workflowList?.datalist2?.[0]?.totalsuspend
                                        : 0}
                                    <span>Suspended</span>
                                </h4>
                            </div>
                            <p>Status</p>
                        </div>
                        <div className="my-machine-top-box-single pending-machines scheduled-machines scheduler-status-box">
                            <div>
                                <h4
                               
                                >
                                    {workflowList?.datalist2?.[0]?.today > 0
                                        ? workflowList?.datalist2?.[0]?.today
                                        : 0}
                                    <span>Today</span>
                                </h4>
                                <h4
                                
                                >
                                    {workflowList?.datalist2?.[0]?.tomorrow > 0
                                        ? workflowList?.datalist2?.[0]?.tomorrow
                                        : 0}
                                    <span>Tomorrow</span>
                                </h4>
                                <h4
                                
                                >
                                    {workflowList?.datalist2?.[0]?.week > 0
                                        ? workflowList?.datalist2?.[0]?.week
                                        : 0}
                                    <span>Week</span>
                                </h4>
                                <h4
                                
                                >
                                    {workflowList?.datalist2?.[0]?.month > 0
                                        ? workflowList?.datalist2?.[0]?.month
                                        : 0}
                                    <span>Month</span>
                                </h4>
                            </div>
                            <p>Scheduled</p>
                        </div>
                        
                    </div>
                </div>
            </Container>
            <div className="main-page-content">
                <Container>
                    <div className="scheduler-table-main">
                        <div className="table-wrapper-main">
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="width175 sticky-workflow text-nowrap">
                                            Workflow Name
                                        </th>
                                        <th className="text-center width125">Machines</th>
                                        <th className="text-center width200">Next schedule</th>
                                        <th className="text-center width200">Last Run</th>
                                        <th className="text-end width125">Last Run Cost</th>
                                        <th className="text-end width125">Avg. Cost</th>
                                        <th className="text-end width125">MTD Cost</th>
                                        <th className="width200">Status</th>
                                        <th className="text-center width150">Cron Expression</th>
                                        <th className="text-center width125">Collaborators</th>
                                        <th className="text-center width200">Created On</th>
                                        <th className="width200">Created By</th>
                                        <th className="text-end  width200 sticky-actions">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Loading ? (
                                        <Loader type={LoaderType.TableRow} count={8} nooftd={13} />
                                    ) : (
                                        <>
                                            {workflowList?.datalist1?.length > 0 ? (
                                                workflowList?.datalist1?.map((item) => {
                                                    if (filter?.length > 0) {
                                                        if (filter?.includes(item?.workflowid)) {
                                                            return (
                                                                <tr key={item?.workflowid}>
                                                                    <td className="theme-color-text fw600 sticky-workflow text-nowrap">
                                                                        {item?.lastrunon ? (
                                                                            <Link
                                                                                to="/scheduler/schedular-detail"
                                                                                state={{
                                                                                    subscriberId: item?.workflowid,
                                                                                    flowName: item?.workflowname,
                                                                                    cronData:
                                                                                        cronstrue.toString(
                                                                                            item?.cronexpression,
                                                                                            {
                                                                                                use24HourTimeFormat: true,
                                                                                            }
                                                                                        ) +
                                                                                        " (" +
                                                                                        item?.timezone +
                                                                                        ")",
                                                                                }}
                                                                            >
                                                                                {commonservices.truncateText(
                                                                                    item?.workflowname,
                                                                                    30
                                                                                )}
                                                                            </Link>
                                                                        ) : (
                                                                            <div
                                                                                // to="/scheduler/schedular-detail"
                                                                                state={{
                                                                                    subscriberId: item?.workflowid,
                                                                                    flowName: item?.workflowname,
                                                                                    cronData:
                                                                                        cronstrue.toString(
                                                                                            item?.cronexpression,
                                                                                            {
                                                                                                use24HourTimeFormat: true,
                                                                                            }
                                                                                        ) +
                                                                                        " (" +
                                                                                        item?.timezone +
                                                                                        ")",
                                                                                }}
                                                                            >
                                                                                {commonservices.truncateText(
                                                                                    item?.workflowname,
                                                                                    30
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {item?.lastrunon ? (
                                                                            <Link
                                                                                to="/scheduler/schedular-detail"
                                                                                state={{
                                                                                    subscriberId: item?.workflowid,
                                                                                }}
                                                                            >
                                                                                {item?.totalmachine || 0}
                                                                            </Link>
                                                                        ) : (
                                                                            <div
                                                                                // to="/scheduler/schedular-detail"
                                                                                state={{
                                                                                    subscriberId: item?.workflowid,
                                                                                }}
                                                                            >
                                                                                {item?.totalmachine || 0}
                                                                            </div>
                                                                        )}
                                                                    </td>

                                                                    <td className="text-center">
                                                                        {item?.nextrunon
                                                                            ? commonservices.convertTimeToLocal(
                                                                                item?.nextrunon
                                                                            )
                                                                            : ""}{" "}
                                                                        <span style={{ fontSize: "9px" }}>
                                                                            
                                                                            {item?.nextrunon
                                                                                ? commonservices.convertDateToLocal(
                                                                                    item?.nextrunon
                                                                                )
                                                                                : ""}{" "}
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {item?.lastrunon
                                                                            ? commonservices.convertTimeToLocal(
                                                                                item?.lastrunon
                                                                            )
                                                                            : ""}{" "}
                                                                        <span style={{ fontSize: "9px" }}>
                                                                            {" "}
                                                                           
                                                                            {item?.lastrunon
                                                                                ? commonservices.convertDateToLocal(
                                                                                    item?.lastrunon
                                                                                )
                                                                                : ""}{" "}
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {" "}
                                                                        {"$ "}
                                                                        {item?.lastruncost
                                                                            ? item?.lastruncost.toFixed(5)
                                                                            : "0.00"}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {"$ "}
                                                                        {item?.avgcost
                                                                            ? item?.avgcost.toFixed(5)
                                                                            : "0.00"}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {"$ "}
                                                                        {item?.mtdcost
                                                                            ? item?.mtdcost.toFixed(5)
                                                                            : "0.00"}
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex">
                                                                            <div className="mt-1 me-1">
                                                                                {commonservices.getStatus(
                                                                                    item?.argoworkflowstatus
                                                                                )}
                                                                            </div>
                                                                            <span className="mt-1">
                                                                                {commonservices.getWithoutDotStatus(
                                                                                    item?.laststatus
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td
                                                                        className="text-center cursor-pointer"
                                                                        title={
                                                                            cronstrue.toString(item?.cronexpression, {
                                                                                use24HourTimeFormat: true,
                                                                            }) +
                                                                            " (" +
                                                                            item?.timezone +
                                                                            ")"
                                                                        }
                                                                    >
                                                                        {item?.cronexpression}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <div className="workflow-assignto">
                                                                            {MemberListFunction(item?.workflowid)
                                                                                ?.length > 4
                                                                                ? MemberListFunction(item?.workflowid)
                                                                                    ?.slice(0, 4)
                                                                                    .map((item, index) => {
                                                                                        return (
                                                                                            <img
                                                                                                src={
                                                                                                    item?.profilepic
                                                                                                        ?.bucketLocation ||
                                                                                                    profileicon
                                                                                                }
                                                                                                alt={item?.displayname}
                                                                                                title={item?.displayname}
                                                                                                key={index}
                                                                                                onError={(e) => {
                                                                                                    e.target.onerror = null;
                                                                                                    e.target.src = profileicon;
                                                                                                }}
                                                                                                style={{ cursor: "pointer" }}
                                                                                            />
                                                                                        );
                                                                                    })
                                                                                : MemberListFunction(
                                                                                    item?.workflowid
                                                                                )?.map((item, index) => {
                                                                                    return (
                                                                                        <img
                                                                                            src={
                                                                                                item?.profilepic
                                                                                                    ?.bucketLocation ||
                                                                                                profileicon
                                                                                            }
                                                                                            alt={item?.displayname}
                                                                                            title={item?.displayname}
                                                                                            key={index}
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = profileicon;
                                                                                            }}
                                                                                            style={{ cursor: "pointer" }}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            {MemberListFunction(item?.workflowid)
                                                                                ?.length > 4 && (
                                                                                    <span
                                                                                        className="workflow-assignto-remaining-images"
                                                                                        style={{ cursor: "pointer" }}
                                                                                    >
                                                                                        +
                                                                                        {MemberListFunction(item?.workflowid)
                                                                                            ?.length - 4}
                                                                                    </span>
                                                                                )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {" "}
                                                                        {item?.createdon
                                                                            ? commonservices.getDateInFormat(
                                                                                item?.createdon
                                                                            )
                                                                            : ""}
                                                                    </td>
                                                                    <td> {item?.displayname || "-"}</td>
                                                                    <td className="sticky-actions">
                                                                        <div className="all-actions Scheduler-page">
                                                                            

                                                                            <img
                                                                                src={actionLog}
                                                                                alt="actionLog"
                                                                                title="Log"
                                                                                onClick={() => {
                                                                                    setModalShow1(true);
                                                                                    setLogId(item?.workflowid);
                                                                                }}
                                                                            />
                                                                            {item?.canview && (
                                                                                <>
                                                                                    
                                                                                    <span
                                                                                        onClick={() => {
                                                                                            let data =
                                                                                                commonservices.bodyEncryption(
                                                                                                    `${item?.workflowid}?v=1&r=sl`
                                                                                                );
                                                                                            navigate(
                                                                                                // `/flow-new/${data}`,
                                                                                                `/flow-new-view/${data}`,
                                                                                                {
                                                                                                    state: {
                                                                                                        isViewMode: true,
                                                                                                        flowRoleRights: item,
                                                                                                    },
                                                                                                }
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            src={viewAction}
                                                                                            alt="viewAction"
                                                                                            title="View"
                                                                                        />
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                            {item?.canedit && (
                                                                                <>
                                                                                   
                                                                                    <span
                                                                                        onClick={() => {
                                                                                            let data =
                                                                                                commonservices.bodyEncryption(
                                                                                                    `${item?.workflowid}?v=0&r=sl`
                                                                                                );
                                                                                            navigate(
                                                                                                `/flow-new/${data}`,
                                                                                                {
                                                                                                    state: {
                                                                                                        isViewMode: false,
                                                                                                        flowRoleRights: item,
                                                                                                    },
                                                                                                }
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            src={editAction}
                                                                                            alt="editAction"
                                                                                            title="Edit"
                                                                                        />
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                            {item?.candelete && (
                                                                                <img
                                                                                    src={deleteAction}
                                                                                    alt="deleteAction"
                                                                                    title="Delete"
                                                                                    onClick={() => {
                                                                                        setModalShow(true);
                                                                                        setDeletePayload({
                                                                                            workflowid: item?.workflowid,
                                                                                            status: "Delete",
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            <></>
                                                        }
                                                    } else {
                                                        return (
                                                            <tr key={item?.workflowid}>
                                                                <td className="theme-color-text fw600 sticky-workflow text-nowrap">
                                                                    {item?.lastrunon ? (
                                                                        <Link
                                                                            to="/scheduler/schedular-detail"
                                                                            state={{
                                                                                subscriberId: item?.workflowid,
                                                                                flowName: item?.workflowname,
                                                                                cronData:
                                                                                    cronstrue.toString(
                                                                                        item?.cronexpression,
                                                                                        {
                                                                                            use24HourTimeFormat: true,
                                                                                        }
                                                                                    ) +
                                                                                    " (" +
                                                                                    item?.timezone +
                                                                                    ")",
                                                                            }}
                                                                        >
                                                                            {commonservices.truncateText(
                                                                                item?.workflowname,
                                                                                30
                                                                            )}
                                                                        </Link>
                                                                    ) : (
                                                                        <div
                                                                            // to="/scheduler/schedular-detail"
                                                                            state={{
                                                                                subscriberId: item?.workflowid,
                                                                                flowName: item?.workflowname,
                                                                                cronData:
                                                                                    cronstrue.toString(
                                                                                        item?.cronexpression,
                                                                                        {
                                                                                            use24HourTimeFormat: true,
                                                                                        }
                                                                                    ) +
                                                                                    " (" +
                                                                                    item?.timezone +
                                                                                    ")",
                                                                            }}
                                                                        >
                                                                            {commonservices.truncateText(
                                                                                item?.workflowname,
                                                                                30
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                <td className="text-center">
                                                                    {item?.lastrunon ? (
                                                                        <Link
                                                                            to="/scheduler/schedular-detail"
                                                                            state={{
                                                                                subscriberId: item?.workflowid,
                                                                            }}
                                                                        >
                                                                            {item?.totalmachine || 0}
                                                                        </Link>
                                                                    ) : (
                                                                        <div
                                                                            // to="/scheduler/schedular-detail"
                                                                            state={{
                                                                                subscriberId: item?.workflowid,
                                                                            }}
                                                                        >
                                                                            {item?.totalmachine || 0}
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                <td className="text-center">
                                                                    {item?.nextrunon
                                                                        ? commonservices.convertTimeToLocal(
                                                                            item?.nextrunon
                                                                        )
                                                                        : ""}{" "}
                                                                    <span style={{ fontSize: "9px" }}>
                                                                        {/* {item?.nextrunon
                                    ? timeZone?.[0]?.shortValue
                                    : ""}{" "} */}
                                                                        {item?.nextrunon
                                                                            ? commonservices.convertDateToLocal(
                                                                                item?.nextrunon
                                                                            )
                                                                            : ""}{" "}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    {item?.lastrunon
                                                                        ? commonservices.convertTimeToLocal(
                                                                            item?.lastrunon
                                                                        )
                                                                        : ""}{" "}
                                                                    <span style={{ fontSize: "9px" }}>
                                                                        {" "}
                                                                        {/* {item?.lastrunon
                                    ? timeZone?.[0]?.shortValue
                                    : ""}{" "} */}
                                                                        {item?.lastrunon
                                                                            ? commonservices.convertDateToLocal(
                                                                                item?.lastrunon
                                                                            )
                                                                            : ""}{" "}
                                                                    </span>
                                                                </td>
                                                                <td className="text-end">
                                                                    {" "}
                                                                    {"$ "}
                                                                    {item?.lastruncost
                                                                        ? item?.lastruncost.toFixed(5)
                                                                        : "0.00"}
                                                                </td>
                                                                <td className="text-end">
                                                                    {"$ "}
                                                                    {item?.avgcost
                                                                        ? item?.avgcost.toFixed(5)
                                                                        : "0.00"}
                                                                </td>
                                                                <td className="text-end">
                                                                    {"$ "}
                                                                    {item?.mtdcost
                                                                        ? item?.mtdcost.toFixed(5)
                                                                        : "0.00"}
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex">
                                                                        <div className="mt-1 me-1">
                                                                            {commonservices.getStatus(
                                                                                item?.argoworkflowstatus
                                                                            )}
                                                                        </div>
                                                                        <span className="mt-1">
                                                                            {commonservices.getWithoutDotStatus(
                                                                                item?.laststatus
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                <td
                                                                    className="text-center cursor-pointer"
                                                                    title={
                                                                        cronstrue.toString(item?.cronexpression, {
                                                                            use24HourTimeFormat: true,
                                                                        }) +
                                                                        " (" +
                                                                        item?.timezone +
                                                                        ")"
                                                                    }
                                                                >
                                                                    {item?.cronexpression}
                                                                </td>
                                                                <td className="text-center">
                                                                    <div className="workflow-assignto">
                                                                        {MemberListFunction(item?.workflowid)
                                                                            ?.length > 4
                                                                            ? MemberListFunction(item?.workflowid)
                                                                                ?.slice(0, 4)
                                                                                .map((item, index) => {
                                                                                    return (
                                                                                        <img
                                                                                            src={
                                                                                                item?.profilepic
                                                                                                    ?.bucketLocation ||
                                                                                                profileicon
                                                                                            }
                                                                                            alt={item?.displayname}
                                                                                            title={item?.displayname}
                                                                                            key={index}
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = profileicon;
                                                                                            }}
                                                                                            style={{ cursor: "pointer" }}
                                                                                        />
                                                                                    );
                                                                                })
                                                                            : MemberListFunction(
                                                                                item?.workflowid
                                                                            )?.map((item, index) => {
                                                                                return (
                                                                                    <img
                                                                                        src={
                                                                                            item?.profilepic
                                                                                                ?.bucketLocation ||
                                                                                            profileicon
                                                                                        }
                                                                                        alt={item?.displayname}
                                                                                        title={item?.displayname}
                                                                                        key={index}
                                                                                        onError={(e) => {
                                                                                            e.target.onerror = null;
                                                                                            e.target.src = profileicon;
                                                                                        }}
                                                                                        style={{ cursor: "pointer" }}
                                                                                    />
                                                                                );
                                                                            })}
                                                                        {MemberListFunction(item?.workflowid)
                                                                            ?.length > 4 && (
                                                                                <span
                                                                                    className="workflow-assignto-remaining-images"
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    +
                                                                                    {MemberListFunction(item?.workflowid)
                                                                                        ?.length - 4}
                                                                                </span>
                                                                            )}
                                                                    </div>
                                                                </td>
                                                                <td className="text-center">
                                                                    {" "}
                                                                    {item?.createdon
                                                                        ? commonservices.getDateInFormat(
                                                                            item?.createdon
                                                                        )
                                                                        : ""}
                                                                </td>
                                                                <td> {item?.displayname || "-"}</td>
                                                                <td className="sticky-actions">
                                                                    <div className="all-actions Scheduler-page">
                                                                        <img
                                                                            src={actionLog}
                                                                            alt="actionLog"
                                                                            title="Log"
                                                                            onClick={() => {
                                                                                setModalShow1(true);
                                                                                setLogId(item?.workflowid);
                                                                            }}
                                                                        />
                                                                        {item?.canview && (
                                                                            <>
                                                                                <span
                                                                                    onClick={() => {
                                                                                        let data =
                                                                                            commonservices.bodyEncryption(
                                                                                                `${item?.workflowid}?v=1&r=sl`
                                                                                            );
                                                                                        navigate(
                                                                                            // `/flow-new/${data}`,
                                                                                            `/flow-new-view/${data}`,
                                                                                            {
                                                                                                state: {
                                                                                                    isViewMode: true,
                                                                                                    flowRoleRights: item,
                                                                                                },
                                                                                            }
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src={viewAction}
                                                                                        alt="viewAction"
                                                                                        title="View"
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                        )}
                                                                        {item?.canedit && (
                                                                            <>
                                                                                <span
                                                                                    onClick={() => {
                                                                                        let data =
                                                                                            commonservices.bodyEncryption(
                                                                                                `${item?.workflowid}?v=0&r=sl`
                                                                                            );
                                                                                        navigate(
                                                                                            `/flow-new/${data}
                                                  `,
                                                                                            {
                                                                                                state: {
                                                                                                    isViewMode: false,
                                                                                                    flowRoleRights: item,
                                                                                                },
                                                                                            }
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src={editAction}
                                                                                        alt="editAction"
                                                                                        title="Edit"
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                        )}
                                                                        {item?.candelete && (
                                                                            <img
                                                                                src={deleteAction}
                                                                                alt="deleteAction"
                                                                                title="Delete"
                                                                                onClick={() => {
                                                                                    setModalShow(true);
                                                                                    setDeletePayload({
                                                                                        workflowid: item?.workflowid,
                                                                                        status: "Delete",
                                                                                    });
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                })
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                            {!workflowList && !Loading && (
                                <>
                                    <Table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <Nodata />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </>
                            )}
                        </div>
                    </div>
                    {/*<div className="scheduler-table-main mt-3">*/}
                    {/*    <WorkFlowTimeLine />*/}
                    {/*</div>*/}
                </Container>

               
            </div>
            {modalShow && (
                <DeleteModal
                    payload={DeletePayload}
                    url={API_URL.WORKFLOW.UPDATE_WORKFLOW_STATUS}
                    show={modalShow}
                    bindlist={getWorkFlowList}
                    onHide={(e) => setModalShow(false)}
                />
            )}
            {/* <LogModal show={modalShow} onHide={() => setModalShow(false)} /> */}
            {showNotification ? (
                <>
                    <Overlay
                        ref={overlayNoti_Ref}
                        target={target2.current}
                        show={showNotification}
                        placement="bottom"
                    >
                        {(props) => (
                            <Tooltip id="overlay-example" {...props}>
                                <NotificationPopup closePopup={handleshowNotification} />
                            </Tooltip>
                        )}
                    </Overlay>
                </>
            ) : (
                ""
            )}
            {modalShow1 && (
                <WorkFlowLogModal
                    show={modalShow1}
                    id={logId}
                    onHide={() => setModalShow1(false)}
                />
            )}
        </div>
    );
}

export default Schedular;
